import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useTranslation } from '../../context/LanguageContext';
import bookIcon from '../../assets/icons/education.png';
import { coursesHeroImage } from '../../assets/siteImages';
import { cardStagger, fadeUp, scrollViewport } from '../../motion/presets';
import '../../components/home-focus/home-focus.scss';
import '../../styles/page-hero-media.scss';
import './courses.scss';

const ICON_MAP = {
  'english_icon.png': bookIcon,
  'home_tuition_icon.png': bookIcon,
};

const CARD_THEMES = ['education', 'work', 'insurance'];

const resolveIcon = (filename) => ICON_MAP[filename] || bookIcon;

const Courses = () => {
  const { content } = useTranslation();
  const p = content.coursesPage;
  const courses = p.items;

  return (
    <main className="courses-page">
      <section className="courses-hero section-full" aria-labelledby="courses-hero-title">
        <div className="container page-hero-split">
          <div className="page-hero-split__copy">
            <motion.p
              className="courses-hero__eyebrow"
              initial="hidden"
              whileInView="visible"
              viewport={scrollViewport}
              variants={fadeUp}
            >
              {p.heroEyebrow}
            </motion.p>
            <motion.h1
              id="courses-hero-title"
              className="courses-hero__title"
              initial="hidden"
              whileInView="visible"
              viewport={scrollViewport}
              variants={fadeUp}
            >
              {p.heroTitle}
            </motion.h1>
            <motion.p
              className="courses-hero__lead"
              initial="hidden"
              whileInView="visible"
              viewport={scrollViewport}
              variants={fadeUp}
            >
              {p.heroLead}
            </motion.p>
            <motion.ul
              className="courses-hero__bullets"
              initial="hidden"
              whileInView="visible"
              viewport={scrollViewport}
              variants={fadeUp}
            >
              {p.bullets.map((line) => (
                <li key={line}>{line}</li>
              ))}
            </motion.ul>
            <motion.p
              className="courses-hero__note"
              initial="hidden"
              whileInView="visible"
              viewport={scrollViewport}
              variants={fadeUp}
            >
              <Link to="/">{p.backHome}</Link>
            </motion.p>
          </div>
          <motion.figure
            className="page-hero-split__media"
            initial="hidden"
            whileInView="visible"
            viewport={scrollViewport}
            variants={fadeUp}
          >
            <img
              className="page-hero-split__photo"
              src={coursesHeroImage}
              alt={p.heroPhotoAlt}
              loading="eager"
              decoding="async"
            />
          </motion.figure>
        </div>
      </section>

      <section className="courses-catalog section-full" aria-labelledby="courses-catalog-title">
        <div className="container">
          <motion.h2
            id="courses-catalog-title"
            className="courses-catalog__title"
            initial="hidden"
            whileInView="visible"
            viewport={scrollViewport}
            variants={fadeUp}
          >
            {p.catalogTitle}
          </motion.h2>
          <motion.div
            className="home-focus__grid courses-catalog__grid"
            variants={cardStagger}
            initial="hidden"
            whileInView="visible"
            viewport={scrollViewport}
          >
            {courses.map((course, index) => {
              const theme = CARD_THEMES[index % CARD_THEMES.length];
              const iconSrc = resolveIcon(course.icon);

              return (
                <motion.article
                  key={course.course_id}
                  className={`home-focus__card home-focus__card--${theme}`}
                  variants={fadeUp}
                >
                  <div className="home-focus__card-top">
                    <div className="home-focus__icon-wrap" aria-hidden="true">
                      <img
                        src={iconSrc}
                        alt=""
                        className="home-focus__icon"
                        width={56}
                        height={56}
                        loading="lazy"
                        decoding="async"
                      />
                    </div>
                  </div>
                  <p className="courses-card__id">{course.course_id}</p>
                  <h3 className="home-focus__card-title">{course.course_title}</h3>
                  <p className="home-focus__card-text">{course.course_description}</p>
                  <Link className="home-focus__card-link" to="/contact?purpose=courses">
                    {p.enquireLink} <span aria-hidden="true">→</span>
                  </Link>
                </motion.article>
              );
            })}
          </motion.div>
        </div>
      </section>
    </main>
  );
};

export default Courses;
